import type { SVGProps } from "react";

export const Edit = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="m9.729 11.89 1.716.23-2.718 1.452A1.349 1.349 0 0 1 7.21 13.4h.002l-1.048-.905a.334.334 0 0 0-.397-.032h.002l-2.244 1.365-.527-.864L5.243 11.6a1.342 1.342 0 0 1 1.583.133l-.002-.001 1.05.906a.339.339 0 0 0 .379.043l1.478-.789H9.73Zm-1.491-1.545L2.24 5.08c-.4-.34-.665-.828-.71-1.379l-.001-.007a2.029 2.029 0 0 1 .476-1.492l.482-.572a2.048 2.048 0 0 1 2.888-.241l-.003-.003 5.997 5.266c.29.247.51.576.627.948l1.162 3.73-3.873-.52a2.047 2.047 0 0 1-1.05-.467l.003.003v-.001ZM2.901 4.313 8.898 9.58c.143.121.327.202.522.229l2.3.309-.69-2.215a1.043 1.043 0 0 0-.32-.484h-.002L4.713 2.152a1.01 1.01 0 0 0-.654-.239h-.005c-.318 0-.602.143-.793.368l-.001.002-.483.57a1.023 1.023 0 0 0-.24.76V3.61c.023.275.151.525.364.704Z"
      />
    </svg>
  );
};
